import type { FormResponseValue } from "@tellescope/types-models";

export interface ChargebeeBillingAddress {
  addressLineOne?: string;
  addressLineTwo?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

/**
 * The billing address sent to `chargebee_details` is the **first** Address answer with a truthy
 * value, in response order — not a specific field, and regardless of whether that address question
 * sits before or after the Chargebee field.
 */
export const getFirstAddressAnswer = (
  responses: FormResponseValue[] | undefined
): ChargebeeBillingAddress | undefined => {
  const match = responses?.find((r) => r.answer?.type === "Address" && !!r.answer.value);
  return match?.answer?.type === "Address" ? match.answer.value : undefined;
};
